import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, unref, normalizeStyle, normalizeClass, toDisplayString, createTextVNode } from "vue";
import { useI18n } from "vue-i18n";
const _hoisted_1 = { class: "auth-hero" };
const _hoisted_2 = {
  class: "auth-hero-stage",
  "aria-hidden": "true"
};
const _hoisted_3 = { class: "auth-hero-space" };
const _hoisted_4 = { class: "auth-hero-field" };
const _hoisted_5 = { class: "auth-hero-copy" };
const _hoisted_6 = { class: "auth-hero-eyebrow" };
const _hoisted_7 = { class: "auth-hero-title" };
const _hoisted_8 = { class: "auth-hero-subtitle" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AuthHero",
  setup(__props) {
    const { t } = useI18n();
    const KIND_BY_CODE = {
      s: "solid",
      m: "tint-60",
      l: "tint-30",
      e: "empty",
      p: "pressed"
    };
    const PATTERN = [
      "smemmmsmless",
      "selseelmssms",
      "sssmsemlmlss",
      "eeelsssslses",
      "eessepesslls",
      "sselssssesms",
      "slslsssseese",
      "sselsesslsss",
      "smsmssemmess"
    ];
    const TONES = ["safran", "cigla", "suma", "more", "sljiva", "ruza", "tirkiz", "grafit"];
    const TILES = PATTERN.flatMap(
      (row, r) => [...row].map((code, c) => ({
        key: `${r}-${c}`,
        kind: KIND_BY_CODE[code],
        tone: TONES[(Math.floor(c / 2) + Math.floor(r / 2) * 3) % TONES.length]
      }))
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("div", _hoisted_4, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(TILES), (tile) => {
                return openBlock(), createElementBlock("div", {
                  key: tile.key,
                  class: normalizeClass(["auth-hero-tile", `auth-hero-tile--${tile.kind}`]),
                  style: normalizeStyle({ "--tile-tone": `var(--pos-tone-${tile.tone})` })
                }, null, 6);
              }), 128))
            ])
          ])
        ]),
        _cache[1] || (_cache[1] = createElementVNode("div", {
          class: "auth-hero-fade",
          "aria-hidden": "true"
        }, null, -1)),
        _cache[2] || (_cache[2] = createElementVNode("div", {
          class: "auth-hero-grain",
          "aria-hidden": "true"
        }, null, -1)),
        createElementVNode("div", _hoisted_5, [
          createElementVNode("div", _hoisted_6, toDisplayString(unref(t)("general.hospitality")) + " · " + toDisplayString(unref(t)("general.retail_and_services")), 1),
          createElementVNode("p", _hoisted_7, [
            createTextVNode(toDisplayString(unref(t)("get_started.hero_title")), 1),
            _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1)),
            createElementVNode("em", null, toDisplayString(unref(t)("get_started.hero_title_accent")), 1)
          ]),
          createElementVNode("p", _hoisted_8, toDisplayString(unref(t)("get_started.hero_subtitle")), 1)
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index34.js.map
